import styled from 'styled-components';

export const Content = styled.div``;

/*
 * Alignment and nothing else.
 *
 * Gone with the move onto AppTable: a hand-rolled `Table` / `Thead` / `Th` /
 * `Td` set at 14px in its own colours, and `TableLoading` / `Loader` — the
 * last white loading scrim in `src/`, an `rgba(255, 255, 255, 0.7)` sheet
 * over the table with the logo and a spinner centred in it. AppTable draws
 * the design's skeleton rows instead.
 */
export const Div = styled.div``;
